<modal-header title="Connect Card Reader"></modal-header>

<ion-content>
    <ion-list>
        <ion-item *ngIf="loaded">
            <ion-label *ngIf="(!terminals || terminals.length === 0)">
                <h3>No terminals have been configured.</h3>
            </ion-label>
            <ion-buttons slot="end">
                <ion-button (click)="openEditTerminal($event, null)">
                    <ion-icon slot="icon-only" color="dark" name="add-outline"></ion-icon>
                </ion-button>
            </ion-buttons>
        </ion-item>
        <ion-radio-group [(ngModel)]="currentTerminal">
            <ion-item *ngFor="let terminal of terminals">
                <ion-label>
                    {{ terminal.nickname }}
                </ion-label>
                <ion-radio slot="start" [value]="terminal" color="success"></ion-radio>
                <ion-buttons slot="end">
                    <ion-button color="dark" (click)="openEditTerminal($event, terminal)">
                        <ion-icon name="create-outline" slot="icon-only"></ion-icon>
                    </ion-button>
                    <ion-button color="dark" (click)="deleteTerminal($event, terminal)">
                        <ion-icon name="trash-outline" slot="icon-only"></ion-icon>
                    </ion-button>
                </ion-buttons>
            </ion-item>
            <ion-item>
                <ion-label>
                    None
                </ion-label>
                <ion-radio slot="start" value="" color="danger"></ion-radio>
            </ion-item>
        </ion-radio-group>
    </ion-list>
</ion-content>

<modal-footer submitLabel="Connect" (submitClicked)="connectTerminal()"></modal-footer>
